import { EMPTY_ARRAY, EMPTY_STRING } from '../../Utilities/Constants/GeneralConstants';
/**
 * @ReduxAction Deletes query state
 */
export const QUERY_CLEANUP = 'QUERY_CLEANUP';
export const QueryCleanup = () => ({
    type: QUERY_CLEANUP,
});
const initialState = {
    NamedQueries: EMPTY_ARRAY,
    CurrentQuery: EMPTY_STRING,
};
export const QueryReducer = (state = initialState, action) => {
    switch (action.type) {
        case QUERY_CLEANUP:
            return initialState;
        default:
            return state;
    }
};
